import { ColorProvider } from '../chart-color-provider';

export const DEFAULT_AREA_OPACITY = 0.2;
export const Y_AXIS_SPLIT_LINES = 5;

export const LINE_CHART_OPTIONS = {
    tooltip: {
        axisPointer: {
            type: 'line',
            lineStyle: {
                width: 11,
            },
        },
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        axisPointer: {
            show: false,
            label: {
                show: false,
            },
        },
    },
    yAxis: {
        type: 'value',
        splitNumber: 1,
        axisPointer: {
            label: {
                precision: 0,
            },
        },
    },
};

export const BASE_SERIES_OPTIONS = {
    type: 'line',
    symbolSize: 6,
    smooth: false,
    itemStyle: {
        borderWidth: 2,
    },
    lineStyle: {
        width: 3,
    },
};

export const BASE_MARK_POINT_OPTIONS = {
    symbol: 'circle',
    symbolSize: (value: number) => 20 + value.toString().length * 5,
    data: [{
        type: 'max',
    }],
};

export const mapLineChartColorOptions = (colorProvider: ColorProvider) => ({
    tooltip: {
        axisPointer: {
            lineStyle: {
                color: colorProvider.axisHoverColor,
            },
        },
    },
});
